package ext

fun String.beginWithLowerCase(): String {
    return when (this.length) {
        0 -> ""
        1 -> this.lowercase()
        else -> this[0].lowercaseChar() + this.substring(1)
    }
}

fun String.beginWithUpperCase(): String {
    return when (this.length) {
        0 -> ""
        1 -> this.uppercase()
        else -> this[0].uppercaseChar() + this.substring(1)
    }
}

fun String.toCamelCase(): String {
    return this.split('_').map { it.beginWithUpperCase() } .joinToString("")
}

fun String.toSnakeCase(): String {
    var text: String = ""
    var isFirst = true
    this.forEach {
        if (it.uppercaseChar().equals(it)) {
            if (isFirst) isFirst = false
            else text += "_"
            text += it.lowercaseChar()
        } else {
            text += it
        }
    }
    return text
}

fun String.digitsOnly(): String{
    val regex = Regex("[^0-9]")
    return regex.replace(this, "")
}

fun String.isNumber(): Boolean{
    var isNumber:Boolean = false
    try{
        val doubleValue = this.toDouble()
        isNumber = true
    }catch (e:Throwable){

    }
    return isNumber;
}

fun String.highlight(keyword:String):String{
    return this.replace(keyword,"<b>${keyword}</b>")
}
